import type { CargoAddressRes } from 'api/swagger';

export function formatAddress(address: CargoAddressRes) {
  return `${address.name}, ${address.address}, ${address.city}, ${address.postCode}`;
}
